import { type TTranscodingSimple, getSourceTranscodingsUrl } from '@core/api'
import { httpClient } from '@core/http-client'

export const getSourceTranscodings = (sourceId: string, { signal }: { signal?: AbortSignal }) => {
    return httpClient
        .get(getSourceTranscodingsUrl(sourceId), {
            signal,
        })
        .json<TTranscodingSimple[]>()
}
